export default "__VITE_ASSET__CE4vyUil__"